import axios from "axios";
import { forgetSignedIn } from "./session";

// The session is an HttpOnly cookie the API sets at sign-in, so no script on
// the page can read the token. The header tells the API this is the web app
// (see App\Support\AuthCookie in the backend).
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:8000/api",
  withCredentials: true,
  headers: { "X-Shuwa-Client": "web" },
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      forgetSignedIn();
    }
    return Promise.reject(err);
  }
);

export default api;
